import { render } from "./SaveEmployeeReportTo.vue?vue&type=template&id=b4c51ade"
import script from "./SaveEmployeeReportTo.vue?vue&type=script&lang=js"
export * from "./SaveEmployeeReportTo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__